import React, { useState, useEffect } from "react";
import { Box, makeStyles, Radio, RadioGroup, FormControlLabel, Grid } from "@material-ui/core";
import Section from "@booking/components/Section";
import validators from "@booking/helpers/validators";
import { Input } from "@booking/helpers/enums";

import Counter from "@shared/components/Counter";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  description: {
    flex: 1,
    display: "flex",
    alignItems: "center",
  },
  notes: {
    color: "gray",
    fontSize: "15px",
    fontWeight: "400",
    marginLeft: "5px",
  },
}));

const StairsField = ({ field, onChange }) => {
  const classes = useStyles();
  const { value } = field;

  const [stairsUsed, setStairsUsed] = useState(!!value);
  const [stairs, setStairs] = useState(value);

  const handleStairsChange = (value) => {
    setStairs(value);
    onChange({ value });
  };

  useEffect(() => {
    onChange({ validation: validators[Input.Stairs](field) });
  }, [value]);

  return (
    <Box className={classes.root}>
      <Section title="Stairs" description="Does the provider need to climb stairs?">
        <Grid container spacing={2} alignItems="flex-start" style={{ height: "65px" }}>
          <Grid item xs={6}>
            <RadioGroup
              row
              aria-label="stairs"
              value={stairsUsed}
              onChange={(e) => {
                setStairsUsed(e.target.value === "true");
                if (e.target.value === "true") {
                  handleStairsChange(1);
                } else {
                  handleStairsChange(0);
                }
              }}>
              <FormControlLabel className={classes.radioControl} control={<Radio color="primary" />} label="Yes" value={true} />
              <FormControlLabel className={classes.radioControl} control={<Radio color="primary" />} label="No" value={false} />
            </RadioGroup>
          </Grid>
          {stairsUsed && (
            <Grid item xs={6}>
              <Counter value={stairs} minValue={1} maxValue={50} onChange={handleStairsChange} />
              <Box className={classes.notes}> x $5 per flight</Box>
            </Grid>
          )}
        </Grid>
      </Section>
    </Box>
  );
};

export default StairsField;
